import { Config } from '../config';
export class PaymentSessionManager {
    constructor() {
        this.currentSession = null;
    }
    async createSession(paymentData, sdkToken) {
        try {
            if (!sdkToken) {
                throw new Error('SDK token required.');
            }
            console.log('💳 Creating payment session');
            console.log('📦 Products:', paymentData.products);
            const config = Config.getInstance();
            const response = await fetch(`${config.getApiBaseUrl()}/v1/checkout/session`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sdkToken}`,
                    'Origin': window.location.origin
                },
                body: JSON.stringify({
                    products: paymentData.products,
                    metadata: paymentData.metadata || {},
                    returnUrl: paymentData.returnUrl || window.location.href
                })
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Failed to create payment session');
            }
            const sessionData = await response.json();
            this.currentSession = sessionData;
            console.log('✅ Payment session created:', sessionData);
            if (sessionData.redirectUrl) {
                console.log('🔄 Redirecting to checkout:', sessionData.redirectUrl);
                window.location.href = sessionData.redirectUrl;
            }
            else {
                throw new Error('No redirect URL provided by API');
            }
            return sessionData;
        }
        catch (error) {
            console.error('❌ Payment session creation error:', error);
            throw error;
        }
    }
    getCurrentSession() {
        return this.currentSession;
    }
    clearSession() {
        this.currentSession = null;
    }
}
